module.exports = __webpack_public_path__ + "static/3-99bd7ac96613b8e15f6cca2106c95b4f.jpg";